// Single source of truth for dev seed credentials. Lives in `src/lib/` (not
// `src/db/`) so the LoginForm can import these constants without pulling the
// postgres client into the browser bundle.

export const DEV_ADMIN_PASSWORD = "admin123!";
export const DEV_MANAGER_PASSWORD = "manager123!";
export const DEV_AUDITOR_PASSWORD = "auditor123!";
export const DEV_STAKEHOLDER_PASSWORD = "stakeholder123!";
